import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import styles from './CopyrightDisplay.module.scss';

export const CopyrightDisplay = (props: { helpCenterLanguage: string }) => {
    const { helpCenterLanguage } = props;
    const copyRightUrl = `/help/${helpCenterLanguage}/articles/609245/how-to-report-copyright-or-trademark-infringement/`;

    return (
        <p className={styles.copyrightText} data-testid="reason_copyright-radio">
            {gettext(
                'Learn more about submitting a Copyright or Trademark Infringement takedown notice',
            )}{' '}
            <a
                href={copyRightUrl}
                rel="noopener noreferrer"
                target="_blank"
                title={gettext(
                    'Link to Reporting Copyright or Trademark Infringement',
                ).toString()}
            >
                {gettext('here')}
            </a>
            .
        </p>
    );
};
